module.exports = __webpack_public_path__ + "static/media/luminous-BG_top-left.bc27b3e9.svg";